export const PymesGeneral = {
  codigo: "PYMES",
  codProducto: "pymesAbiertoInd",
  prodCodigoCore: "pymesAbiertoInd",
  proTipoPlan: "Abierto",

  urls: {
    datosPersonales: "/pymes1",
    datosGenerales: "/pymes2",
    datosUbicaciones: "/pymes3",
    datosResumen: "/pymes5",

    emisionContratante: "/pymes-emision-contratante",
    emisionAsegurado: "/pymes-emision-asegurado",
    vigenciaPoliza: "/pymes-vigencia-poliza",
    pagoPoliza: "/pymes-pago-poliza",
    finCompra: "/pymes-fin-compra",
    facturacion:'/facturacion/tipo-persona',
  },

  /********Produccion********/
  encriptar: {
    resumen: true,
    catalogo: true,
    actualizar: true,
    tarifar: true,
    recuperar: true,
    emitirPoliza: true,
    contratante: true,
    asegurado: true,
  },

  logueoRequerido: true,
};

export const PresuscritoGeneral = {
  codigo: "PYMES",
  codProducto: "pymesCerradoInd",
  prodCodigoCore: "pymesCerradoInd",
  proTipoPlan: "Abierto",

  urls: {
    datosPersonales: "/pymes1",
    ubicacion: "/presuscrito-ubicacion",
    planes: "/presuscrito-planes",
    resumen: "/presuscrito-resumen",

    emisionContratante: "/presuscrito-contratante",
    emisionAsegurado: "/presuscrito-asegurado",
    pagoPoliza: "/pymes-pagopresuscrito-poliza",
    finCompra: "/presuscrito-compra",
    facturacion:'/facturacion/tipo-persona',
  },

  /********Produccion********/
  encriptar: {
    resumen: true,
    catalogo: true,
    actualizar: true,
    tarifar: true,
    recuperar: true,
    emitirPoliza: true,
    contratante: true,
    asegurado: true,
  },

  logueoRequerido: true,

};
